import { useEffect, useRef, useState } from 'react';
import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItemButton, ListItemText } from '@mui/material';
import { listDecisionAgentThreads } from '../../services/api';
import { agentOwner } from './agentDelivery';

export default function AgentHistoryDialog({ open, owner, onClose, onSelect }) {
  const [rows, setRows] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const generation = useRef(0);

  const load = async (next, token) => {
    setBusy(true);
    setError(null);
    try {
      const response = await listDecisionAgentThreads(next);
      if (token !== generation.current || agentOwner() !== owner) return;
      setRows((previous) => next ? [...previous, ...response.data.conversations] : response.data.conversations);
      setCursor(response.data.next_cursor);
    } catch (_) {
      if (token === generation.current && agentOwner() === owner) setError('Conversation history could not be loaded. Try again.');
    } finally {
      if (token === generation.current) setBusy(false);
    }
  };

  useEffect(() => {
    const token = ++generation.current;
    setRows([]);
    setCursor(null);
    setError(null);
    setBusy(false);
    if (open && owner && agentOwner() === owner) load(null, token);
    return () => { generation.current += 1; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, owner]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Conversation history</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" action={<Button onClick={() => load(cursor, generation.current)}>Retry</Button>}>{error}</Alert>}
        <List>
          {rows.map((row) => (
            <ListItemButton key={row.thread_id} onClick={() => { if (agentOwner() === owner) onSelect(row); }}>
              <ListItemText primary={row.title} secondary={`${new Date(row.updated_at).toLocaleString()} · ${row.page.replace(/_/g, ' ')}${row.status === 'ended' ? ' · Ended (read only)' : ''}`} />
            </ListItemButton>
          ))}
        </List>
        {busy && <CircularProgress size={24} aria-label="Loading conversation history" />}
        {!busy && !error && rows.length === 0 && <p>No conversations yet.</p>}
      </DialogContent>
      <DialogActions>
        {cursor && <Button disabled={busy} onClick={() => load(cursor, generation.current)}>Load more</Button>}
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
